
var coinCost = JSON.parse('1');

agneta.directive('EcTopup', function($rootScope, remote, $timeout, data, Role_Account_Manager) {

  var vm = this;

  vm.member = data.member;
  vm.coins = 0;
  vm.coinCost = coinCost;

  vm.addCoins = function(value){
    if(!vm.coins){
      vm.coins = 0;
    }
    vm.coins += value;
  };

  vm.$watch('coins',function(value){
    value = parseInt(value);
    if(value<0){
      value = 0;
    }

    vm.coins = value;
    vm.free = getFreeCoins(value);

    if(!value){
      vm.cost = 0;
      return;
    }

    vm.cost = value * coinCost;
  });

  function getFreeCoins(value){
    var result = 0;

    result += parseInt(value/50)*8;
    value = value%50;

    result += parseInt(value/20)*3;
    value = value%20;

    result += parseInt(value/10);

    return result;
  }

  vm.submit = function() {

    vm.loading = true;
    var fields = {
      accountId: data.account.id,
      amount: vm.cost,
      free: vm.free,
      coins: vm.coins
    };
    //console.log(fields);
    return Role_Account_Manager.topupSubmit(fields)
      .$promise
      .then(function(result) {
        //console.log(result);
      });

  };

});
